import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import logo from "../assets/img/mun_logo.jpg";
import munlogo from "../assets/img/logo.jpg";
import Addlogo_web from "../assets/img/logo-web.png";
import Addlogo_mobile from "../assets/img/logo-mobile.png";
import govLogo from "../assets/img/Goverment.png";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import MoreIcon from "@material-ui/icons/MoreVert";
import Pdf_ar from "../assets/docs/manual_Ar.pdf";
import Pdf_en from "../assets/docs/manual_En.pdf";
import {
  Link,
  Avatar,
  Popover,
  MenuItem,
  Button,
  IconButton,
  Popper,
  Grow,
  Paper,
  MenuList,
  SwipeableDrawer,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { makeStyles } from "@material-ui/core/styles";
import { deepPurple } from "@material-ui/core/colors";
import { useTranslation } from "react-i18next";
import PersonIcon from "@material-ui/icons/Person";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { useSelector, useDispatch } from "react-redux";
import {
  setActivePage,
  setActiveLanguage,
  setUserCredentials,
} from "../redux/actions/appSettingsActions";
import { appConifg } from "../config/default";
import axios from "axios";
import { setSidePanelResultType } from "../redux/actions/mapPanelControlActions";
import { useCookies } from "react-cookie";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: "flex",
    },
    purple: {
      color: theme.palette.getContrastText(deepPurple[500]),
      backgroundColor: deepPurple[500],
    },
    loggedInUserAvatar: {
      backgroundColor: theme.palette.primary.light,
    },
    headerDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
      justifyContent: "space-between",
    },
    headerMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
      background: "linear-gradient(180deg, #f2f2f2, #f2f2f2 90%)",
      color: "#555",
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
      background: "linear-gradient(180deg, #f2f2f2, #f2f2f2 90%)",
      color: "#555",
    },
    languageIcon: {
      margin: theme.spacing(1),
    },
  }),
  { index: 1 }
);

function Header(props) {
  const classes = useStyles();
  const pageSettings = useSelector((state) => state.settings);
  const addressingResult = useSelector((state) => state.addressingResult);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("header");

  const [anchorEl, setAnchorEl] = useState(null);
  const signOpen = Boolean(anchorEl);
  const history = useHistory();
  const [cookiesStore, setCookieStore] = useCookies(["store", "langauge"]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSignClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    dispatch(setActivePage(newValue));
    switch (newValue) {
      case "Home":
        history.push("/");
        break;
      case "Map":
        history.push("/Map");
        break;
      case "Contact":
        history.push("/Contact");
        break;
      default:
        history.push("/");
    }
  };
  const handleLangChange = () => {
    dispatch(setActiveLanguage(pageSettings.language === "en" ? "ar" : "en"));
  };
  useEffect(() => {
    i18n.changeLanguage(pageSettings.language);
    //
    if (pageSettings.language == "en") {
      document.body.classList.remove("rtllayout");
      document.body.classList.add("ltrlayout");
    } else {
      document.body.classList.remove("ltrlayout");
      document.body.classList.add("rtllayout");
    }
  }, [pageSettings.language]);
  const handleSignout = () => {
    if (pageSettings.userCredentials.uaePassUser) {
      if (addressingResult)
        setCookieStore("store", JSON.stringify(addressingResult), {
          path: "/",
        });
      setCookieStore("language", JSON.stringify(pageSettings.language), {
        path: "/",
      });
      window.location.replace(
        appConifg.UaePassDetails.logoutUrl +
          "?redirect_uri=" +
          appConifg.UaePassDetails.redirectUrl
      );
    } else {
      let data = {};
      let axiosConfig = {
        headers: {
          username: appConifg.AnonymousUser.username,
          password: appConifg.AnonymousUser.password,
        },
      };
      axios
        .post(
          appConifg.Address.AddressApiUrl + "/Users/Login",
          data,
          axiosConfig
        )
        .then((response) => {
          if (response.data?.isSucceeded) {
            dispatch(
              setUserCredentials({ data: response.data.data, flag: false })
            );
            dispatch(setSidePanelResultType("address"));
            handleSignClose();
          } else {
            dispatch(setUserCredentials({ data: null, flag: false }));
            dispatch(setSidePanelResultType("address"));
            handleSignClose();
          }
        })
        .catch((ex) => {
          console.log(ex);
          dispatch(setUserCredentials({ data: null, flag: false }));
          dispatch(setSidePanelResultType("address"));
          handleSignClose();
        });
    }
  };
  const [mobilePopperOpen, setMobilePopperOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setMobilePopperOpen((prevOpen) => !prevOpen);
  };
  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setMobilePopperOpen(false);
    }
  }
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setMobilePopperOpen(false);
  };

  return (
    // <header id="header" className="adressingjss3">
    //   <div className="container menu-bar d-flex justify-content-between align-items-center">
    //     <h1 className="logo me-auto">
    //       <img
    //         src={logo}
    //         width="auto"
    //         height="60"
    //         className="d-inline-block align-top"
    //         alt="React Bootstrap logo"
    //       />
    //     </h1>
    //     <div className={classes.sectionDesktop}>
    //       <Tabs
    //         value={pageSettings.activePage}
    //         onChange={handleChange}
    //         indicatorColor="primary"
    //         textColor="primary"
    //         centered
    //       >
    //         <Tab value="Map" label={t("Addressing")} />
    //         <Tab value="Contact" label={t("Contact")} />
    //       </Tabs>
    //       <nav id="navbar" className="navbar">
    //         <ul>
    //           <li>
    //             <Button
    //               variant="outlined"
    //               color="secondary"
    //               onClick={handleLangChange}
    //               className={classes.languageIcon}
    //             >
    //               {pageSettings.language === "en" ? "عربى" : "English"}
    //             </Button>
    //           </li>
    //           {!pageSettings.isLoggedIn ? (
    //             <li>
    //               <Button
    //                 variant="contained"
    //                 color="primary"
    //                 onClick={() => {
    //                   history.push("/Login");
    //                 }}
    //                 startIcon={<PersonIcon />}
    //               >
    //                 {t("SignIn")}
    //               </Button>
    //             </li>
    //           ) : (
    //             <li>
    //               <Avatar
    //                 className={classes.loggedInUserAvatar}
    //                 aria-label="more"
    //                 aria-controls="user-menu"
    //                 aria-haspopup="true"
    //                 onClick={handleClick}
    //               >
    //                 {pageSettings.userCredentials.user
    //                   ? pageSettings.userCredentials.user.name
    //                       .charAt(0)
    //                       .toUpperCase()
    //                   : pageSettings.userCredentials.acmUser.name
    //                       .charAt(0)
    //                       .toUpperCase()}
    //               </Avatar>
    //               <Popover
    //                 id="user-menu"
    //                 open={signOpen}
    //                 anchorEl={anchorEl}
    //                 onClose={handleSignClose}
    //                 anchorOrigin={{
    //                   vertical: "bottom",
    //                   horizontal: "center",
    //                 }}
    //                 transformOrigin={{
    //                   vertical: "top",
    //                   horizontal: "center",
    //                 }}
    //                 PaperProps={{
    //                   style: {
    //                     width: "20ch",
    //                   },
    //                 }}
    //               >
    //                 {pageSettings.userCredentials.user ? (
    //                   pageSettings.userCredentials.user.userTypeName ===
    //                   "External" ? (
    //                     <MenuItem
    //                       key={"reset"}
    //                       onClick={() => {
    //                         history.push("/Login");
    //                         handleSignClose();
    //                       }}
    //                     >
    //                       {t("Reset")}
    //                     </MenuItem>
    //                   ) : (
    //                     ""
    //                   )
    //                 ) : (
    //                   ""
    //                 )}
    //                 <MenuItem key={"logout"} onClick={handleSignout}>
    //                   {t("logout")}
    //                 </MenuItem>
    //               </Popover>
    //             </li>
    //           )}
    //         </ul>
    //       </nav>
    //     </div>
    //     <div className={classes.sectionMobile}>
    //       <Button
    //         variant="outlined"
    //         color="secondary"
    //         onClick={handleLangChange}
    //         className={classes.languageIcon}
    //       >
    //         {pageSettings.language === "en" ? "عربى" : "English"}
    //       </Button>
    //       <IconButton
    //         aria-label="show more"
    //         aria-controls={mobilePopperOpen ? "menu-list-grow" : undefined}
    //         aria-haspopup="true"
    //         color="inherit"
    //         onClick={handleToggle}
    //       >
    //         <MoreIcon />
    //       </IconButton>
    //       <SwipeableDrawer
    //         anchor="top"
    //         open={mobilePopperOpen}
    //         onClose={handleClose}
    //         onOpen={() => console.log("Open Drawer")}
    //       >
    //         <Paper>
    //           <ClickAwayListener onClickAway={handleClose}>
    //             <MenuList
    //               autoFocusItem={mobilePopperOpen}
    //               id="menu-list-grow"
    //               onKeyDown={handleListKeyDown}
    //             >
    //               <MenuItem
    //                 onClick={() => {
    //                   history.push("/Map");
    //                   handleClose();
    //                 }}
    //               >
    //                 {t("Addressing")}
    //               </MenuItem>
    //               <MenuItem
    //                 onClick={() => {
    //                   history.push("/Contact");
    //                   handleClose();
    //                 }}
    //               >
    //                 {t("Contact")}
    //               </MenuItem>
    //               {!pageSettings.isLoggedIn ? (
    //                 <MenuItem
    //                   onClick={() => {
    //                     history.push("/Login");
    //                     handleClose();
    //                   }}
    //                 >
    //                   {" "}
    //                   {t("SignIn")}
    //                 </MenuItem>
    //               ) : pageSettings.userCredentials.user ? (
    //                 pageSettings.userCredentials.user.userTypeName ===
    //                 "External" ? (
    //                   <MenuItem
    //                     key={"reset"}
    //                     onClick={() => {
    //                       history.push("/Login");
    //                       handleClose();
    //                       handleSignClose();
    //                     }}
    //                   >
    //                     {t("Reset")}
    //                   </MenuItem>
    //                 ) : (
    //                   ""
    //                 )
    //               ) : (
    //                 ""
    //               )}
    //               {pageSettings.isLoggedIn ? (
    //                 <MenuItem
    //                   key={"logout"}
    //                   onClick={() => {
    //                     handleSignout();
    //                     handleClose();
    //                   }}
    //                 >
    //                   {t("logout")}
    //                 </MenuItem>
    //               ) : (
    //                 ""
    //               )}
    //             </MenuList>
    //           </ClickAwayListener>
    //         </Paper>
    //       </SwipeableDrawer>
    //     </div>
    //   </div>
    // </header>
    <header>
      <div className={classes.headerDesktop}>
        <nav className="navbar logo header-navbar">
          <a className="navbar-brand d-flex float-left">
            <img
              src={String(govLogo)}
              width="auto"
              height="48"
              className="d-inline-block align-top logo"
              alt=""
            />
          </a>
          {/* <a className="navbar-brand">
            <img
              src={String(Addlogo_web)}
              width="auto"
              height="60"
              className="d-inline-block align-top logo"
              alt=""
            />
          </a> */}
          <a className="navbar-right gov-log">
            <img
              src={String(logo)}
              width="auto"
              height="60"
              className="d-inline-block align-top logo"
              alt=""
            />
          </a>
        </nav>
      </div>
      <div className={classes.headerMobile}>
        <nav className="navbar logo">
          {/* <a className="navbar-brand">
            <img
              src={String(Addlogo_mobile)}
              width="auto"
              height="45"
              className="d-inline-block align-top logo"
              alt=""
            />
          </a> */}
          <a className="navbar-right gov-log">
            <img
              src={String(logo)}
              width="auto"
              height="46"
              className="d-inline-block align-top logo"
              alt=""
            />
          </a>
        </nav>
      </div>
      <div className={classes.sectionDesktop}>
        <div className="container menu-bar d-flex justify-content-between">
          <Tabs
            value={pageSettings.activePage}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab value="Map" label={t("Addressing")} />
            <Tab value="Contact" label={t("Contact")} />
          </Tabs>
          <nav id="navbar" className="navbar justify-content-end">
            <ul>
              <li>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleLangChange}
                  className={classes.languageIcon}
                >
                  {pageSettings.language === "en" ? "عربى" : "English"}
                </Button>
              </li>

              {!pageSettings.isLoggedIn ? (
                <li>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      history.push("/Login");
                    }}
                    startIcon={<PersonIcon />}
                  >
                    {t("SignIn")}
                  </Button>
                </li>
              ) : (
                <li>
                  <Avatar
                    className={classes.loggedInUserAvatar}
                    aria-label="more"
                    aria-controls="user-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    {pageSettings.userCredentials.user
                      ? pageSettings.userCredentials.user.name
                          .charAt(0)
                          .toUpperCase()
                      : pageSettings.userCredentials.acmUser.name
                          .charAt(0)
                          .toUpperCase()}
                  </Avatar>
                  <Popover
                    id="user-menu"
                    open={signOpen}
                    anchorEl={anchorEl}
                    onClose={handleSignClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    PaperProps={{
                      style: {
                        width: "20ch",
                      },
                    }}
                  >
                    {pageSettings.userCredentials.user ? (
                      pageSettings.userCredentials.user.userTypeName ===
                      "External" ? (
                        <MenuItem
                          key={"reset"}
                          onClick={() => {
                            history.push("/Login");
                            handleSignClose();
                          }}
                        >
                          {t("Reset")}
                        </MenuItem>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    <MenuItem key={"logout"} onClick={handleSignout}>
                      {t("logout")}
                    </MenuItem>
                  </Popover>
                </li>
              )}
              <li>
                <a
                  href={pageSettings.language == "en" ? Pdf_en : Pdf_ar}
                  without
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <HelpIcon />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className={classes.sectionMobile}>
        <IconButton
          aria-label="show more"
          aria-controls={mobilePopperOpen ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          color="inherit"
          onClick={handleToggle}
        >
          <MoreIcon />
        </IconButton>
        <SwipeableDrawer
          anchor="top"
          open={mobilePopperOpen}
          onClose={handleClose}
          onOpen={() => console.log("Open Drawer")}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList
                autoFocusItem={mobilePopperOpen}
                id="menu-list-grow"
                onKeyDown={handleListKeyDown}
              >
                <MenuItem
                  onClick={() => {
                    history.push("/Map");
                    handleClose();
                  }}
                >
                  {t("Addressing")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    history.push("/Contact");
                    handleClose();
                  }}
                >
                  {t("Contact")}
                </MenuItem>
                {!pageSettings.isLoggedIn ? (
                  <MenuItem
                    onClick={() => {
                      history.push("/Login");
                      handleClose();
                    }}
                  >
                    {" "}
                    {t("SignIn")}
                  </MenuItem>
                ) : pageSettings.userCredentials.user ? (
                  pageSettings.userCredentials.user.userTypeName ===
                  "External" ? (
                    <MenuItem
                      key={"reset"}
                      onClick={() => {
                        history.push("/Login");
                        handleClose();
                        handleSignClose();
                      }}
                    >
                      {t("Reset")}
                    </MenuItem>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {pageSettings.isLoggedIn ? (
                  <MenuItem
                    key={"logout"}
                    onClick={() => {
                      handleSignout();
                      handleClose();
                    }}
                  >
                    {t("logout")}
                  </MenuItem>
                ) : (
                  ""
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </SwipeableDrawer>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleLangChange}
          className={classes.languageIcon}
        >
          {pageSettings.language === "en" ? "عربى" : "English"}
        </Button>
      </div>
    </header>
  );
}

export default Header;
